/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddOrUpdateOrderReqVo,
  AdditionalServiceVo,
  BatchAdminRemarkReqVo,
  BatchOrderReqVo,
  BatchUploadBlCodeReqVo,
  BatchUploadIvcCodeVo,
  BoxSplitOrderReqVo,
  ChildTrackingNumberVo,
  KoreaReturnApplicationReqVo,
  KoreaReturnOrderCreateReqVo,
  MergeOrderReqVo,
  OrderDetailUpdateAdditionalServiceVo,
  OrderReceiveAddressVo,
  ResponseBoxSplitOrderInfoVo,
  ResponseChineseWaybillVo,
  ResponseCoupangUploadFilesVo,
  ResponseExcelAnalysisVo,
  ResponseKoreaStockProcessOrderInfoVo,
  ResponseKoreaWaybillVo,
  ResponseListAdditionalServiceVo,
  ResponseListI18nCodeOption,
  ResponseListInteger,
  ResponseListKoreaCancelOrderInfoVo,
  ResponseListKoreaReturnApplicationOrderVo,
  ResponseListOrderType,
  ResponseListRequestTypeVo,
  ResponseLong,
  ResponseOrderBoxTrackingNumberVo,
  ResponseOrderDetailVo,
  ResponseOrderInfoForKoreaReturnVo,
  ResponseOrderInfoForSimpleFromRocketVo,
  ResponseOrderInfoForSplitVo,
  ResponseOrderStatisticsRespVo,
  ResponseOrderVo,
  ResponseReturnInfoVo,
  ResponseString,
  ResponseUpdateCoupangInfoVo,
  ReturnFromCoupangApplyProcessReqVo,
  ReturnFromCoupangConfirmVo,
  ReturnInfoVo,
  SplitOrderReqVo,
  SplitSimpleFromRocketReqVo,
  UpdateCoupangInfoVo,
  UploadReturnOutboundInfoVo,
  WarehouseRemarkVo,
} from '../models/index';
import {
    AddOrUpdateOrderReqVoFromJSON,
    AddOrUpdateOrderReqVoToJSON,
    AdditionalServiceVoFromJSON,
    AdditionalServiceVoToJSON,
    BatchAdminRemarkReqVoFromJSON,
    BatchAdminRemarkReqVoToJSON,
    BatchOrderReqVoFromJSON,
    BatchOrderReqVoToJSON,
    BatchUploadBlCodeReqVoFromJSON,
    BatchUploadBlCodeReqVoToJSON,
    BatchUploadIvcCodeVoFromJSON,
    BatchUploadIvcCodeVoToJSON,
    BoxSplitOrderReqVoFromJSON,
    BoxSplitOrderReqVoToJSON,
    ChildTrackingNumberVoFromJSON,
    ChildTrackingNumberVoToJSON,
    KoreaReturnApplicationReqVoFromJSON,
    KoreaReturnApplicationReqVoToJSON,
    KoreaReturnOrderCreateReqVoFromJSON,
    KoreaReturnOrderCreateReqVoToJSON,
    MergeOrderReqVoFromJSON,
    MergeOrderReqVoToJSON,
    OrderDetailUpdateAdditionalServiceVoFromJSON,
    OrderDetailUpdateAdditionalServiceVoToJSON,
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoToJSON,
    ResponseBoxSplitOrderInfoVoFromJSON,
    ResponseBoxSplitOrderInfoVoToJSON,
    ResponseChineseWaybillVoFromJSON,
    ResponseChineseWaybillVoToJSON,
    ResponseCoupangUploadFilesVoFromJSON,
    ResponseCoupangUploadFilesVoToJSON,
    ResponseExcelAnalysisVoFromJSON,
    ResponseExcelAnalysisVoToJSON,
    ResponseKoreaStockProcessOrderInfoVoFromJSON,
    ResponseKoreaStockProcessOrderInfoVoToJSON,
    ResponseKoreaWaybillVoFromJSON,
    ResponseKoreaWaybillVoToJSON,
    ResponseListAdditionalServiceVoFromJSON,
    ResponseListAdditionalServiceVoToJSON,
    ResponseListI18nCodeOptionFromJSON,
    ResponseListI18nCodeOptionToJSON,
    ResponseListIntegerFromJSON,
    ResponseListIntegerToJSON,
    ResponseListKoreaCancelOrderInfoVoFromJSON,
    ResponseListKoreaCancelOrderInfoVoToJSON,
    ResponseListKoreaReturnApplicationOrderVoFromJSON,
    ResponseListKoreaReturnApplicationOrderVoToJSON,
    ResponseListOrderTypeFromJSON,
    ResponseListOrderTypeToJSON,
    ResponseListRequestTypeVoFromJSON,
    ResponseListRequestTypeVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponseOrderBoxTrackingNumberVoFromJSON,
    ResponseOrderBoxTrackingNumberVoToJSON,
    ResponseOrderDetailVoFromJSON,
    ResponseOrderDetailVoToJSON,
    ResponseOrderInfoForKoreaReturnVoFromJSON,
    ResponseOrderInfoForKoreaReturnVoToJSON,
    ResponseOrderInfoForSimpleFromRocketVoFromJSON,
    ResponseOrderInfoForSimpleFromRocketVoToJSON,
    ResponseOrderInfoForSplitVoFromJSON,
    ResponseOrderInfoForSplitVoToJSON,
    ResponseOrderStatisticsRespVoFromJSON,
    ResponseOrderStatisticsRespVoToJSON,
    ResponseOrderVoFromJSON,
    ResponseOrderVoToJSON,
    ResponseReturnInfoVoFromJSON,
    ResponseReturnInfoVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
    ResponseUpdateCoupangInfoVoFromJSON,
    ResponseUpdateCoupangInfoVoToJSON,
    ReturnFromCoupangApplyProcessReqVoFromJSON,
    ReturnFromCoupangApplyProcessReqVoToJSON,
    ReturnFromCoupangConfirmVoFromJSON,
    ReturnFromCoupangConfirmVoToJSON,
    ReturnInfoVoFromJSON,
    ReturnInfoVoToJSON,
    SplitOrderReqVoFromJSON,
    SplitOrderReqVoToJSON,
    SplitSimpleFromRocketReqVoFromJSON,
    SplitSimpleFromRocketReqVoToJSON,
    UpdateCoupangInfoVoFromJSON,
    UpdateCoupangInfoVoToJSON,
    UploadReturnOutboundInfoVoFromJSON,
    UploadReturnOutboundInfoVoToJSON,
    WarehouseRemarkVoFromJSON,
    WarehouseRemarkVoToJSON,
} from '../models/index';

export interface OrderAdminRemarkOrderIdPutRequest {
    orderId: number;
    adminRemark: string;
}

export interface OrderAnalysisExcelPostRequest {
    orderType: number;
    file: Blob;
}

export interface OrderBatchAdminRemarkPutRequest {
    batchAdminRemarkReqVo?: BatchAdminRemarkReqVo;
}

export interface OrderBatchOrderPostRequest {
    batchOrderReqVo?: BatchOrderReqVo;
}

export interface OrderBatchUpdateParcelTrackingNumberOrderIdPutRequest {
    orderId: number;
    trackingNumber: string;
}

export interface OrderBatchUploadBLCodePutRequest {
    batchUploadBlCodeReqVo?: BatchUploadBlCodeReqVo;
}

export interface OrderBatchUploadIVCCodeOrderIdPostRequest {
    orderId: number;
    batchUploadIvcCodeVo?: BatchUploadIvcCodeVo;
}

export interface OrderBoxSplitOrderInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderChangeAdditionalServiceOrderIdPostRequest {
    orderId: number;
    additionalServiceVo?: Array<AdditionalServiceVo>;
}

export interface OrderChangeOrderInfoOrderIdPutRequest {
    orderId: number;
    requestType: number;
    internationalTransportMethodId?: number;
}

export interface OrderChangePaymentTypeOrderIdPutRequest {
    orderId: number;
}

export interface OrderChangeReceiverInfoOrderIdPostRequest {
    orderId: number;
    orderReceiveAddressVo?: OrderReceiveAddressVo;
}

export interface OrderCopyOrderFromOrderSnapshotOrderSnapshotIdPostRequest {
    orderSnapshotId: number;
}

export interface OrderCopyOrderOrderIdPostRequest {
    orderId: number;
}

export interface OrderCreate3PLReturnOrderOrderIdPutRequest {
    orderId: number;
}

export interface OrderDeleteBLCodeOrderIdDeleteRequest {
    orderId: number;
}

export interface OrderDownloadBusinessFilePostRequest {
    orderId: number;
}

export interface OrderDownloadExcelBatchOrderTemplatePostRequest {
    orderType: number;
}

export interface OrderGetBusinessFileUrlPostRequest {
    orderId: number;
}

export interface OrderGetChineseWaybillOrderIdPutRequest {
    orderId: number;
}

export interface OrderGetInternalTransportMethodIdGetRequest {
    requestType: number;
}

export interface OrderGetKoreaStockProcessOrderInfoOrderIdPutRequest {
    orderId: number;
}

export interface OrderGetKoreaWaybillOrderIdPutRequest {
    orderId: number;
}

export interface OrderGetOrderAdditionalServicesOrderIdGetRequest {
    orderId: number;
}

export interface OrderGetOrderBoxTrackingNumberOrderIdGetRequest {
    orderId: number;
}

export interface OrderGetOrderInfoForKoreaReturnOrderIdPutRequest {
    orderId: number;
}

export interface OrderGetReturnInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderKoreaReturnApplicationGetRequest {
    marketBarcode?: string;
    coupangInboundCode?: string;
    orderCode?: string;
}

export interface OrderKoreaReturnApplicationPostRequest {
    koreaReturnApplicationReqVo?: KoreaReturnApplicationReqVo;
}

export interface OrderKoreaReturnOrderPostRequest {
    koreaReturnOrderCreateReqVo?: KoreaReturnOrderCreateReqVo;
}

export interface OrderMergeOrderPostRequest {
    mergeOrderReqVo?: MergeOrderReqVo;
}

export interface OrderOrderCoupangUploadFilesOrderIdGetRequest {
    orderId: number;
}

export interface OrderOrderOrderIdDeleteRequest {
    orderId: number;
}

export interface OrderOrderOrderIdGetRequest {
    orderId: number;
}

export interface OrderOrderPostRequest {
    addOrUpdateOrderReqVo?: AddOrUpdateOrderReqVo;
}

export interface OrderOrderSimpleOrderIdGetRequest {
    orderId: number;
}

export interface OrderRequestTypeCanChangeGetRequest {
    orderStatus: number;
    requestType: number;
}

export interface OrderResetSplitRocketOrderOrderIdPutRequest {
    orderId: number;
}

export interface OrderReturnFromCoupangApplyProcessPostRequest {
    returnFromCoupangApplyProcessReqVo?: ReturnFromCoupangApplyProcessReqVo;
}

export interface OrderReturnFromCoupangConfirmPutRequest {
    returnFromCoupangConfirmVo?: ReturnFromCoupangConfirmVo;
}

export interface OrderRewriteIvcOrderIdPutRequest {
    orderId: number;
}

export interface OrderSplitOrderByBoxesPostRequest {
    boxSplitOrderReqVo?: BoxSplitOrderReqVo;
}

export interface OrderSplitOrderInfoOrderIdGetRequest {
    orderId: number;
}

export interface OrderSplitOrderPostRequest {
    splitOrderReqVo?: SplitOrderReqVo;
}

export interface OrderSplitRocketOrderOrderIdPutRequest {
    orderId: number;
}

export interface OrderSplitSimpleFromRocketPostRequest {
    splitSimpleFromRocketReqVo?: SplitSimpleFromRocketReqVo;
}

export interface OrderStatisticsAnnualSummaryGetRequest {
    year?: number;
    warehouseId?: number;
}

export interface OrderSubmitOrderIdPutRequest {
    orderId: number;
}

export interface OrderUpdateAdditionalServiceOrderIdPutRequest {
    orderId: number;
    orderDetailUpdateAdditionalServiceVo?: OrderDetailUpdateAdditionalServiceVo;
}

export interface OrderUpdateBoxCountOrderIdPutRequest {
    orderId: number;
    totalBoxCount: number;
}

export interface OrderUpdateChildrenTrackingNumberPutRequest {
    childTrackingNumberVo?: Array<ChildTrackingNumberVo>;
}

export interface OrderUpdateCoupangReturnOrderProcessMethodOrderIdPutRequest {
    orderId: number;
    returnFromCoupangProcessMethod: number;
}

export interface OrderUpdateOrderInfoOrderIdPostRequest {
    orderId: number;
    updateCoupangInfoVo?: UpdateCoupangInfoVo;
}

export interface OrderUpdateReturnInfoPostRequest {
    returnInfoVo?: ReturnInfoVo;
}

export interface OrderUpdateWarehouseRemarkOrderIdPostRequest {
    orderId: number;
    warehouseRemarkVo?: WarehouseRemarkVo;
}

export interface OrderUploadBLCodeOrderIdPutRequest {
    orderId: number;
    bLNo: string;
}

export interface OrderUploadIVCCodeOrderIdPutRequest {
    orderId: number;
    ivc: string;
    outboundDate: string;
}

export interface OrderUploadReturnCodeOrderIdPutRequest {
    orderId: number;
    returnCode: string;
}

export interface OrderUploadReturnOutboundInfoOrderIdPutRequest {
    orderId: number;
    uploadReturnOutboundInfoVo?: UploadReturnOutboundInfoVo;
}

export interface OrderUploadTransOrderInfoPostRequest {
    file: Blob;
}

/**
 * 
 */
export class OrderControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 管理员备注
     */
    async orderAdminRemarkOrderIdPutRaw(requestParameters: OrderAdminRemarkOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderAdminRemarkOrderIdPut().'
            );
        }

        if (requestParameters['adminRemark'] == null) {
            throw new runtime.RequiredError(
                'adminRemark',
                'Required parameter "adminRemark" was null or undefined when calling orderAdminRemarkOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['adminRemark'] != null) {
            queryParameters['adminRemark'] = requestParameters['adminRemark'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/adminRemark/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 管理员备注
     */
    async orderAdminRemarkOrderIdPut(requestParameters: OrderAdminRemarkOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderAdminRemarkOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 解析excel文件
     */
    async orderAnalysisExcelPostRaw(requestParameters: OrderAnalysisExcelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseExcelAnalysisVo>> {
        if (requestParameters['orderType'] == null) {
            throw new runtime.RequiredError(
                'orderType',
                'Required parameter "orderType" was null or undefined when calling orderAnalysisExcelPost().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling orderAnalysisExcelPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/order/analysisExcel`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseExcelAnalysisVoFromJSON(jsonValue));
    }

    /**
     * 
     * 解析excel文件
     */
    async orderAnalysisExcelPost(requestParameters: OrderAnalysisExcelPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseExcelAnalysisVo> {
        const response = await this.orderAnalysisExcelPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量管理员备注
     */
    async orderBatchAdminRemarkPutRaw(requestParameters: OrderBatchAdminRemarkPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/batchAdminRemark`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchAdminRemarkReqVoToJSON(requestParameters['batchAdminRemarkReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量管理员备注
     */
    async orderBatchAdminRemarkPut(requestParameters: OrderBatchAdminRemarkPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBatchAdminRemarkPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传批量下单
     */
    async orderBatchOrderPostRaw(requestParameters: OrderBatchOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/batchOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchOrderReqVoToJSON(requestParameters['batchOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传批量下单
     */
    async orderBatchOrderPost(requestParameters: OrderBatchOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBatchOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量更新商品快递单号
     */
    async orderBatchUpdateParcelTrackingNumberOrderIdPutRaw(requestParameters: OrderBatchUpdateParcelTrackingNumberOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBatchUpdateParcelTrackingNumberOrderIdPut().'
            );
        }

        if (requestParameters['trackingNumber'] == null) {
            throw new runtime.RequiredError(
                'trackingNumber',
                'Required parameter "trackingNumber" was null or undefined when calling orderBatchUpdateParcelTrackingNumberOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['trackingNumber'] != null) {
            queryParameters['trackingNumber'] = requestParameters['trackingNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/batchUpdateParcelTrackingNumber/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量更新商品快递单号
     */
    async orderBatchUpdateParcelTrackingNumberOrderIdPut(requestParameters: OrderBatchUpdateParcelTrackingNumberOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBatchUpdateParcelTrackingNumberOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量上传BL单号
     */
    async orderBatchUploadBLCodePutRaw(requestParameters: OrderBatchUploadBLCodePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/batchUploadBLCode`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUploadBlCodeReqVoToJSON(requestParameters['batchUploadBlCodeReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量上传BL单号
     */
    async orderBatchUploadBLCodePut(requestParameters: OrderBatchUploadBLCodePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBatchUploadBLCodePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 批量上传ivc运单号
     */
    async orderBatchUploadIVCCodeOrderIdPostRaw(requestParameters: OrderBatchUploadIVCCodeOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBatchUploadIVCCodeOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/batchUploadIVCCode/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BatchUploadIvcCodeVoToJSON(requestParameters['batchUploadIvcCodeVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 批量上传ivc运单号
     */
    async orderBatchUploadIVCCodeOrderIdPost(requestParameters: OrderBatchUploadIVCCodeOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderBatchUploadIVCCodeOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 按箱拆分候选与当前资格
     */
    async orderBoxSplitOrderInfoOrderIdGetRaw(requestParameters: OrderBoxSplitOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoxSplitOrderInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderBoxSplitOrderInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/boxSplitOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBoxSplitOrderInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 按箱拆分候选与当前资格
     */
    async orderBoxSplitOrderInfoOrderIdGet(requestParameters: OrderBoxSplitOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoxSplitOrderInfoVo> {
        const response = await this.orderBoxSplitOrderInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改订单附加服务
     */
    async orderChangeAdditionalServiceOrderIdPostRaw(requestParameters: OrderChangeAdditionalServiceOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderChangeAdditionalServiceOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/changeAdditionalService/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['additionalServiceVo']!.map(AdditionalServiceVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改订单附加服务
     */
    async orderChangeAdditionalServiceOrderIdPost(requestParameters: OrderChangeAdditionalServiceOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderChangeAdditionalServiceOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端 订单详情页  变更订单
     */
    async orderChangeOrderInfoOrderIdPutRaw(requestParameters: OrderChangeOrderInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderChangeOrderInfoOrderIdPut().'
            );
        }

        if (requestParameters['requestType'] == null) {
            throw new runtime.RequiredError(
                'requestType',
                'Required parameter "requestType" was null or undefined when calling orderChangeOrderInfoOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        if (requestParameters['internationalTransportMethodId'] != null) {
            queryParameters['internationalTransportMethodId'] = requestParameters['internationalTransportMethodId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/changeOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端 订单详情页  变更订单
     */
    async orderChangeOrderInfoOrderIdPut(requestParameters: OrderChangeOrderInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderChangeOrderInfoOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 变更订单支付方式
     */
    async orderChangePaymentTypeOrderIdPutRaw(requestParameters: OrderChangePaymentTypeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderChangePaymentTypeOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/changePaymentType/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 变更订单支付方式
     */
    async orderChangePaymentTypeOrderIdPut(requestParameters: OrderChangePaymentTypeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderChangePaymentTypeOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改订单收货人信息
     */
    async orderChangeReceiverInfoOrderIdPostRaw(requestParameters: OrderChangeReceiverInfoOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderChangeReceiverInfoOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/changeReceiverInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OrderReceiveAddressVoToJSON(requestParameters['orderReceiveAddressVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改订单收货人信息
     */
    async orderChangeReceiverInfoOrderIdPost(requestParameters: OrderChangeReceiverInfoOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderChangeReceiverInfoOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 从订单快照复制订单
     */
    async orderCopyOrderFromOrderSnapshotOrderSnapshotIdPostRaw(requestParameters: OrderCopyOrderFromOrderSnapshotOrderSnapshotIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderVo>> {
        if (requestParameters['orderSnapshotId'] == null) {
            throw new runtime.RequiredError(
                'orderSnapshotId',
                'Required parameter "orderSnapshotId" was null or undefined when calling orderCopyOrderFromOrderSnapshotOrderSnapshotIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/copyOrderFromOrderSnapshot/{orderSnapshotId}`.replace(`{${"orderSnapshotId"}}`, encodeURIComponent(String(requestParameters['orderSnapshotId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 从订单快照复制订单
     */
    async orderCopyOrderFromOrderSnapshotOrderSnapshotIdPost(requestParameters: OrderCopyOrderFromOrderSnapshotOrderSnapshotIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderVo> {
        const response = await this.orderCopyOrderFromOrderSnapshotOrderSnapshotIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 复制订单
     */
    async orderCopyOrderOrderIdPostRaw(requestParameters: OrderCopyOrderOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCopyOrderOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/copyOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 复制订单
     */
    async orderCopyOrderOrderIdPost(requestParameters: OrderCopyOrderOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderVo> {
        const response = await this.orderCopyOrderOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建3pl退货单
     */
    async orderCreate3PLReturnOrderOrderIdPutRaw(requestParameters: OrderCreate3PLReturnOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderCreate3PLReturnOrderOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/create3PLReturnOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 创建3pl退货单
     */
    async orderCreate3PLReturnOrderOrderIdPut(requestParameters: OrderCreate3PLReturnOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderCreate3PLReturnOrderOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除BL单号
     */
    async orderDeleteBLCodeOrderIdDeleteRaw(requestParameters: OrderDeleteBLCodeOrderIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderDeleteBLCodeOrderIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/deleteBLCode/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除BL单号
     */
    async orderDeleteBLCodeOrderIdDelete(requestParameters: OrderDeleteBLCodeOrderIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderDeleteBLCodeOrderIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 下载营业执照副本
     */
    async orderDownloadBusinessFilePostRaw(requestParameters: OrderDownloadBusinessFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderDownloadBusinessFilePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/downloadBusinessFile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 下载营业执照副本
     */
    async orderDownloadBusinessFilePost(requestParameters: OrderDownloadBusinessFilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderDownloadBusinessFilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 下载批量下单模板文件
     */
    async orderDownloadExcelBatchOrderTemplatePostRaw(requestParameters: OrderDownloadExcelBatchOrderTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['orderType'] == null) {
            throw new runtime.RequiredError(
                'orderType',
                'Required parameter "orderType" was null or undefined when calling orderDownloadExcelBatchOrderTemplatePost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/downloadExcelBatchOrderTemplate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 
     * 下载批量下单模板文件
     */
    async orderDownloadExcelBatchOrderTemplatePost(requestParameters: OrderDownloadExcelBatchOrderTemplatePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.orderDownloadExcelBatchOrderTemplatePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取营业执照副本url
     */
    async orderGetBusinessFileUrlPostRaw(requestParameters: OrderGetBusinessFileUrlPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetBusinessFileUrlPost().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderId'] != null) {
            queryParameters['orderId'] = requestParameters['orderId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getBusinessFileUrl`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 获取营业执照副本url
     */
    async orderGetBusinessFileUrlPost(requestParameters: OrderGetBusinessFileUrlPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderGetBusinessFileUrlPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取中国运单信息
     */
    async orderGetChineseWaybillOrderIdPutRaw(requestParameters: OrderGetChineseWaybillOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseChineseWaybillVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetChineseWaybillOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getChineseWaybill/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseChineseWaybillVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取中国运单信息
     */
    async orderGetChineseWaybillOrderIdPut(requestParameters: OrderGetChineseWaybillOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseChineseWaybillVo> {
        const response = await this.orderGetChineseWaybillOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 按订单申请类型 获取国际运输方式
     */
    async orderGetInternalTransportMethodIdGetRaw(requestParameters: OrderGetInternalTransportMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListInteger>> {
        if (requestParameters['requestType'] == null) {
            throw new runtime.RequiredError(
                'requestType',
                'Required parameter "requestType" was null or undefined when calling orderGetInternalTransportMethodIdGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getInternalTransportMethodId`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListIntegerFromJSON(jsonValue));
    }

    /**
     * 
     * 按订单申请类型 获取国际运输方式
     */
    async orderGetInternalTransportMethodIdGet(requestParameters: OrderGetInternalTransportMethodIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListInteger> {
        const response = await this.orderGetInternalTransportMethodIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取待回库订单信息
     */
    async orderGetKoreaCancelOrderInfoGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListKoreaCancelOrderInfoVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getKoreaCancelOrderInfo`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListKoreaCancelOrderInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取待回库订单信息
     */
    async orderGetKoreaCancelOrderInfoGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListKoreaCancelOrderInfoVo> {
        const response = await this.orderGetKoreaCancelOrderInfoGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 韩国3pl库存有误商品计算费用的订单信息
     */
    async orderGetKoreaStockProcessOrderInfoOrderIdPutRaw(requestParameters: OrderGetKoreaStockProcessOrderInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKoreaStockProcessOrderInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetKoreaStockProcessOrderInfoOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getKoreaStockProcessOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKoreaStockProcessOrderInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 韩国3pl库存有误商品计算费用的订单信息
     */
    async orderGetKoreaStockProcessOrderInfoOrderIdPut(requestParameters: OrderGetKoreaStockProcessOrderInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKoreaStockProcessOrderInfoVo> {
        const response = await this.orderGetKoreaStockProcessOrderInfoOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取韩国运单信息
     */
    async orderGetKoreaWaybillOrderIdPutRaw(requestParameters: OrderGetKoreaWaybillOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKoreaWaybillVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetKoreaWaybillOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getKoreaWaybill/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKoreaWaybillVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取韩国运单信息
     */
    async orderGetKoreaWaybillOrderIdPut(requestParameters: OrderGetKoreaWaybillOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKoreaWaybillVo> {
        const response = await this.orderGetKoreaWaybillOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单·获取测费附加服务
     * 订单·获取测费附加服务
     */
    async orderGetOrderAdditionalServicesOrderIdGetRaw(requestParameters: OrderGetOrderAdditionalServicesOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListAdditionalServiceVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetOrderAdditionalServicesOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getOrderAdditionalServices/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListAdditionalServiceVoFromJSON(jsonValue));
    }

    /**
     * 订单·获取测费附加服务
     * 订单·获取测费附加服务
     */
    async orderGetOrderAdditionalServicesOrderIdGet(requestParameters: OrderGetOrderAdditionalServicesOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListAdditionalServiceVo> {
        const response = await this.orderGetOrderAdditionalServicesOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 改箱数和改子运单号的回显数据接口
     */
    async orderGetOrderBoxTrackingNumberOrderIdGetRaw(requestParameters: OrderGetOrderBoxTrackingNumberOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderBoxTrackingNumberVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetOrderBoxTrackingNumberOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getOrderBoxTrackingNumber/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderBoxTrackingNumberVoFromJSON(jsonValue));
    }

    /**
     * 
     * 改箱数和改子运单号的回显数据接口
     */
    async orderGetOrderBoxTrackingNumberOrderIdGet(requestParameters: OrderGetOrderBoxTrackingNumberOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderBoxTrackingNumberVo> {
        const response = await this.orderGetOrderBoxTrackingNumberOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 给返送订单下单用的订单信息
     */
    async orderGetOrderInfoForKoreaReturnOrderIdPutRaw(requestParameters: OrderGetOrderInfoForKoreaReturnOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForKoreaReturnVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetOrderInfoForKoreaReturnOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getOrderInfoForKoreaReturn/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForKoreaReturnVoFromJSON(jsonValue));
    }

    /**
     * 
     * 给返送订单下单用的订单信息
     */
    async orderGetOrderInfoForKoreaReturnOrderIdPut(requestParameters: OrderGetOrderInfoForKoreaReturnOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForKoreaReturnVo> {
        const response = await this.orderGetOrderInfoForKoreaReturnOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取退货信息
     */
    async orderGetReturnInfoOrderIdGetRaw(requestParameters: OrderGetReturnInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseReturnInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderGetReturnInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/getReturnInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseReturnInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取退货信息
     */
    async orderGetReturnInfoOrderIdGet(requestParameters: OrderGetReturnInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseReturnInfoVo> {
        const response = await this.orderGetReturnInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 历史订单筛选申请类别
     */
    async orderHistoryRequestTypesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListI18nCodeOption>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/history-request-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListI18nCodeOptionFromJSON(jsonValue));
    }

    /**
     * 
     * 历史订单筛选申请类别
     */
    async orderHistoryRequestTypesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListI18nCodeOption> {
        const response = await this.orderHistoryRequestTypesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 历史订单筛选服务类型
     */
    async orderHistoryServiceTypesGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListI18nCodeOption>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/history-service-types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListI18nCodeOptionFromJSON(jsonValue));
    }

    /**
     * 
     * 历史订单筛选服务类型
     */
    async orderHistoryServiceTypesGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListI18nCodeOption> {
        const response = await this.orderHistoryServiceTypesGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 查询韩国出库商品返送申请候选订单
     */
    async orderKoreaReturnApplicationGetRaw(requestParameters: OrderKoreaReturnApplicationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListKoreaReturnApplicationOrderVo>> {
        const queryParameters: any = {};

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['coupangInboundCode'] != null) {
            queryParameters['coupangInboundCode'] = requestParameters['coupangInboundCode'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/koreaReturnApplication`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListKoreaReturnApplicationOrderVoFromJSON(jsonValue));
    }

    /**
     * 
     * 查询韩国出库商品返送申请候选订单
     */
    async orderKoreaReturnApplicationGet(requestParameters: OrderKoreaReturnApplicationGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListKoreaReturnApplicationOrderVo> {
        const response = await this.orderKoreaReturnApplicationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 提交韩国出库商品返送申请
     */
    async orderKoreaReturnApplicationPostRaw(requestParameters: OrderKoreaReturnApplicationPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/koreaReturnApplication`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KoreaReturnApplicationReqVoToJSON(requestParameters['koreaReturnApplicationReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 提交韩国出库商品返送申请
     */
    async orderKoreaReturnApplicationPost(requestParameters: OrderKoreaReturnApplicationPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderKoreaReturnApplicationPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 管理端·生成返送订单
     */
    async orderKoreaReturnOrderPostRaw(requestParameters: OrderKoreaReturnOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/koreaReturnOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: KoreaReturnOrderCreateReqVoToJSON(requestParameters['koreaReturnOrderCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 管理端·生成返送订单
     */
    async orderKoreaReturnOrderPost(requestParameters: OrderKoreaReturnOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.orderKoreaReturnOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 合单
     */
    async orderMergeOrderPostRaw(requestParameters: OrderMergeOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/mergeOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MergeOrderReqVoToJSON(requestParameters['mergeOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 合单
     */
    async orderMergeOrderPost(requestParameters: OrderMergeOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderMergeOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取coupang上传文件信息
     */
    async orderOrderCoupangUploadFilesOrderIdGetRaw(requestParameters: OrderOrderCoupangUploadFilesOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCoupangUploadFilesVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderOrderCoupangUploadFilesOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/order/coupangUploadFiles/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCoupangUploadFilesVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取coupang上传文件信息
     */
    async orderOrderCoupangUploadFilesOrderIdGet(requestParameters: OrderOrderCoupangUploadFilesOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCoupangUploadFilesVo> {
        const response = await this.orderOrderCoupangUploadFilesOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除订单
     */
    async orderOrderOrderIdDeleteRaw(requestParameters: OrderOrderOrderIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderOrderOrderIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/order/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除订单
     */
    async orderOrderOrderIdDelete(requestParameters: OrderOrderOrderIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderOrderOrderIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单详情
     */
    async orderOrderOrderIdGetRaw(requestParameters: OrderOrderOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderDetailVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderOrderOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/order/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderDetailVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单详情
     */
    async orderOrderOrderIdGet(requestParameters: OrderOrderOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderDetailVo> {
        const response = await this.orderOrderOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 创建订单
     */
    async orderOrderPostRaw(requestParameters: OrderOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/order`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddOrUpdateOrderReqVoToJSON(requestParameters['addOrUpdateOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 创建订单
     */
    async orderOrderPost(requestParameters: OrderOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.orderOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 给火箭订单拆分快递件查询订单信息
     */
    async orderOrderSimpleOrderIdGetRaw(requestParameters: OrderOrderSimpleOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForSimpleFromRocketVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderOrderSimpleOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/order/simple/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForSimpleFromRocketVoFromJSON(jsonValue));
    }

    /**
     * 
     * 给火箭订单拆分快递件查询订单信息
     */
    async orderOrderSimpleOrderIdGet(requestParameters: OrderOrderSimpleOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForSimpleFromRocketVo> {
        const response = await this.orderOrderSimpleOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取系统内所有订单类型
     */
    async orderOrderTypeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListOrderType>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/orderType`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListOrderTypeFromJSON(jsonValue));
    }

    /**
     * 
     * 获取系统内所有订单类型
     */
    async orderOrderTypeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListOrderType> {
        const response = await this.orderOrderTypeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取可转换的订单类型
     */
    async orderRequestTypeCanChangeGetRaw(requestParameters: OrderRequestTypeCanChangeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListRequestTypeVo>> {
        if (requestParameters['orderStatus'] == null) {
            throw new runtime.RequiredError(
                'orderStatus',
                'Required parameter "orderStatus" was null or undefined when calling orderRequestTypeCanChangeGet().'
            );
        }

        if (requestParameters['requestType'] == null) {
            throw new runtime.RequiredError(
                'requestType',
                'Required parameter "requestType" was null or undefined when calling orderRequestTypeCanChangeGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['orderStatus'] != null) {
            queryParameters['orderStatus'] = requestParameters['orderStatus'];
        }

        if (requestParameters['requestType'] != null) {
            queryParameters['requestType'] = requestParameters['requestType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/requestTypeCanChange`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListRequestTypeVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取可转换的订单类型
     */
    async orderRequestTypeCanChangeGet(requestParameters: OrderRequestTypeCanChangeGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListRequestTypeVo> {
        const response = await this.orderRequestTypeCanChangeGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 重置快递件申请
     */
    async orderResetSplitRocketOrderOrderIdPutRaw(requestParameters: OrderResetSplitRocketOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderResetSplitRocketOrderOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/resetSplitRocketOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 重置快递件申请
     */
    async orderResetSplitRocketOrderOrderIdPut(requestParameters: OrderResetSplitRocketOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderResetSplitRocketOrderOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 确认请求状态批量申请处理：单订单流转确认作业，多订单合并为一个新订单
     */
    async orderReturnFromCoupangApplyProcessPostRaw(requestParameters: OrderReturnFromCoupangApplyProcessPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/returnFromCoupangApplyProcess`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReturnFromCoupangApplyProcessReqVoToJSON(requestParameters['returnFromCoupangApplyProcessReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 确认请求状态批量申请处理：单订单流转确认作业，多订单合并为一个新订单
     */
    async orderReturnFromCoupangApplyProcessPost(requestParameters: OrderReturnFromCoupangApplyProcessPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderReturnFromCoupangApplyProcessPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 返送订单确认
     */
    async orderReturnFromCoupangConfirmPutRaw(requestParameters: OrderReturnFromCoupangConfirmPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/returnFromCoupangConfirm`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReturnFromCoupangConfirmVoToJSON(requestParameters['returnFromCoupangConfirmVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 返送订单确认
     */
    async orderReturnFromCoupangConfirmPut(requestParameters: OrderReturnFromCoupangConfirmPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderReturnFromCoupangConfirmPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 重新签发运单
     */
    async orderRewriteIvcOrderIdPutRaw(requestParameters: OrderRewriteIvcOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderRewriteIvcOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/rewriteIvc/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 重新签发运单
     */
    async orderRewriteIvcOrderIdPut(requestParameters: OrderRewriteIvcOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderRewriteIvcOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 按保存包装箱拆分订单
     */
    async orderSplitOrderByBoxesPostRaw(requestParameters: OrderSplitOrderByBoxesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/splitOrderByBoxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BoxSplitOrderReqVoToJSON(requestParameters['boxSplitOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 
     * 按保存包装箱拆分订单
     */
    async orderSplitOrderByBoxesPost(requestParameters: OrderSplitOrderByBoxesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.orderSplitOrderByBoxesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取订单信息 分单使用
     */
    async orderSplitOrderInfoOrderIdGetRaw(requestParameters: OrderSplitOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderInfoForSplitVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderSplitOrderInfoOrderIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/splitOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderInfoForSplitVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取订单信息 分单使用
     */
    async orderSplitOrderInfoOrderIdGet(requestParameters: OrderSplitOrderInfoOrderIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderInfoForSplitVo> {
        const response = await this.orderSplitOrderInfoOrderIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 分单
     */
    async orderSplitOrderPostRaw(requestParameters: OrderSplitOrderPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/splitOrder`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SplitOrderReqVoToJSON(requestParameters['splitOrderReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 分单
     */
    async orderSplitOrderPost(requestParameters: OrderSplitOrderPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderSplitOrderPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 从火箭订单 分裂快递件订单
     */
    async orderSplitRocketOrderOrderIdPutRaw(requestParameters: OrderSplitRocketOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderSplitRocketOrderOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/splitRocketOrder/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 从火箭订单 分裂快递件订单
     */
    async orderSplitRocketOrderOrderIdPut(requestParameters: OrderSplitRocketOrderOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderSplitRocketOrderOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 给火箭订单拆分快递件
     */
    async orderSplitSimpleFromRocketPostRaw(requestParameters: OrderSplitSimpleFromRocketPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/splitSimpleFromRocket`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SplitSimpleFromRocketReqVoToJSON(requestParameters['splitSimpleFromRocketReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 给火箭订单拆分快递件
     */
    async orderSplitSimpleFromRocketPost(requestParameters: OrderSplitSimpleFromRocketPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderSplitSimpleFromRocketPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 订单年度统计 按年份和仓库统计完成订单数据，包含KPI卡片、月度趋势和明细
     * 订单年度统计
     */
    async orderStatisticsAnnualSummaryGetRaw(requestParameters: OrderStatisticsAnnualSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseOrderStatisticsRespVo>> {
        const queryParameters: any = {};

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/statistics/annual-summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseOrderStatisticsRespVoFromJSON(jsonValue));
    }

    /**
     * 订单年度统计 按年份和仓库统计完成订单数据，包含KPI卡片、月度趋势和明细
     * 订单年度统计
     */
    async orderStatisticsAnnualSummaryGet(requestParameters: OrderStatisticsAnnualSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseOrderStatisticsRespVo> {
        const response = await this.orderStatisticsAnnualSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 临时存储订单提交为正式订单
     */
    async orderSubmitOrderIdPutRaw(requestParameters: OrderSubmitOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderSubmitOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/submit/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 临时存储订单提交为正式订单
     */
    async orderSubmitOrderIdPut(requestParameters: OrderSubmitOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderSubmitOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 订单详情页 更新订单附加服务
     */
    async orderUpdateAdditionalServiceOrderIdPutRaw(requestParameters: OrderUpdateAdditionalServiceOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUpdateAdditionalServiceOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateAdditionalService/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrderDetailUpdateAdditionalServiceVoToJSON(requestParameters['orderDetailUpdateAdditionalServiceVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 订单详情页 更新订单附加服务
     */
    async orderUpdateAdditionalServiceOrderIdPut(requestParameters: OrderUpdateAdditionalServiceOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateAdditionalServiceOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改总箱数
     */
    async orderUpdateBoxCountOrderIdPutRaw(requestParameters: OrderUpdateBoxCountOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUpdateBoxCountOrderIdPut().'
            );
        }

        if (requestParameters['totalBoxCount'] == null) {
            throw new runtime.RequiredError(
                'totalBoxCount',
                'Required parameter "totalBoxCount" was null or undefined when calling orderUpdateBoxCountOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['totalBoxCount'] != null) {
            queryParameters['totalBoxCount'] = requestParameters['totalBoxCount'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateBoxCount/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改总箱数
     */
    async orderUpdateBoxCountOrderIdPut(requestParameters: OrderUpdateBoxCountOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateBoxCountOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改子运单号
     */
    async orderUpdateChildrenTrackingNumberPutRaw(requestParameters: OrderUpdateChildrenTrackingNumberPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateChildrenTrackingNumber`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['childTrackingNumberVo']!.map(ChildTrackingNumberVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改子运单号
     */
    async orderUpdateChildrenTrackingNumberPut(requestParameters: OrderUpdateChildrenTrackingNumberPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateChildrenTrackingNumberPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 返送处理方式修改
     */
    async orderUpdateCoupangReturnOrderProcessMethodOrderIdPutRaw(requestParameters: OrderUpdateCoupangReturnOrderProcessMethodOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUpdateCoupangReturnOrderProcessMethodOrderIdPut().'
            );
        }

        if (requestParameters['returnFromCoupangProcessMethod'] == null) {
            throw new runtime.RequiredError(
                'returnFromCoupangProcessMethod',
                'Required parameter "returnFromCoupangProcessMethod" was null or undefined when calling orderUpdateCoupangReturnOrderProcessMethodOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['returnFromCoupangProcessMethod'] != null) {
            queryParameters['returnFromCoupangProcessMethod'] = requestParameters['returnFromCoupangProcessMethod'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateCoupangReturnOrderProcessMethod/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 返送处理方式修改
     */
    async orderUpdateCoupangReturnOrderProcessMethodOrderIdPut(requestParameters: OrderUpdateCoupangReturnOrderProcessMethodOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateCoupangReturnOrderProcessMethodOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新订单coupang信息
     */
    async orderUpdateOrderInfoOrderIdPostRaw(requestParameters: OrderUpdateOrderInfoOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseUpdateCoupangInfoVo>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUpdateOrderInfoOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateOrderInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCoupangInfoVoToJSON(requestParameters['updateCoupangInfoVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseUpdateCoupangInfoVoFromJSON(jsonValue));
    }

    /**
     * 
     * 更新订单coupang信息
     */
    async orderUpdateOrderInfoOrderIdPost(requestParameters: OrderUpdateOrderInfoOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseUpdateCoupangInfoVo> {
        const response = await this.orderUpdateOrderInfoOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 修改退货信息
     */
    async orderUpdateReturnInfoPostRaw(requestParameters: OrderUpdateReturnInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateReturnInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReturnInfoVoToJSON(requestParameters['returnInfoVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 修改退货信息
     */
    async orderUpdateReturnInfoPost(requestParameters: OrderUpdateReturnInfoPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateReturnInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新仓库备注
     */
    async orderUpdateWarehouseRemarkOrderIdPostRaw(requestParameters: OrderUpdateWarehouseRemarkOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUpdateWarehouseRemarkOrderIdPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/updateWarehouseRemark/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: WarehouseRemarkVoToJSON(requestParameters['warehouseRemarkVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新仓库备注
     */
    async orderUpdateWarehouseRemarkOrderIdPost(requestParameters: OrderUpdateWarehouseRemarkOrderIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUpdateWarehouseRemarkOrderIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传BL单号
     */
    async orderUploadBLCodeOrderIdPutRaw(requestParameters: OrderUploadBLCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUploadBLCodeOrderIdPut().'
            );
        }

        if (requestParameters['bLNo'] == null) {
            throw new runtime.RequiredError(
                'bLNo',
                'Required parameter "bLNo" was null or undefined when calling orderUploadBLCodeOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['bLNo'] != null) {
            queryParameters['BLNo'] = requestParameters['bLNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/uploadBLCode/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传BL单号
     */
    async orderUploadBLCodeOrderIdPut(requestParameters: OrderUploadBLCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUploadBLCodeOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传ivc运单号
     */
    async orderUploadIVCCodeOrderIdPutRaw(requestParameters: OrderUploadIVCCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUploadIVCCodeOrderIdPut().'
            );
        }

        if (requestParameters['ivc'] == null) {
            throw new runtime.RequiredError(
                'ivc',
                'Required parameter "ivc" was null or undefined when calling orderUploadIVCCodeOrderIdPut().'
            );
        }

        if (requestParameters['outboundDate'] == null) {
            throw new runtime.RequiredError(
                'outboundDate',
                'Required parameter "outboundDate" was null or undefined when calling orderUploadIVCCodeOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ivc'] != null) {
            queryParameters['ivc'] = requestParameters['ivc'];
        }

        if (requestParameters['outboundDate'] != null) {
            queryParameters['outboundDate'] = requestParameters['outboundDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/uploadIVCCode/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传ivc运单号
     */
    async orderUploadIVCCodeOrderIdPut(requestParameters: OrderUploadIVCCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUploadIVCCodeOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传退货单号
     */
    async orderUploadReturnCodeOrderIdPutRaw(requestParameters: OrderUploadReturnCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUploadReturnCodeOrderIdPut().'
            );
        }

        if (requestParameters['returnCode'] == null) {
            throw new runtime.RequiredError(
                'returnCode',
                'Required parameter "returnCode" was null or undefined when calling orderUploadReturnCodeOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['returnCode'] != null) {
            queryParameters['returnCode'] = requestParameters['returnCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/uploadReturnCode/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传退货单号
     */
    async orderUploadReturnCodeOrderIdPut(requestParameters: OrderUploadReturnCodeOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUploadReturnCodeOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传退货出库信息
     */
    async orderUploadReturnOutboundInfoOrderIdPutRaw(requestParameters: OrderUploadReturnOutboundInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['orderId'] == null) {
            throw new runtime.RequiredError(
                'orderId',
                'Required parameter "orderId" was null or undefined when calling orderUploadReturnOutboundInfoOrderIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/order/uploadReturnOutboundInfo/{orderId}`.replace(`{${"orderId"}}`, encodeURIComponent(String(requestParameters['orderId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UploadReturnOutboundInfoVoToJSON(requestParameters['uploadReturnOutboundInfoVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传退货出库信息
     */
    async orderUploadReturnOutboundInfoOrderIdPut(requestParameters: OrderUploadReturnOutboundInfoOrderIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUploadReturnOutboundInfoOrderIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 上传运输订单 修改商品信息
     */
    async orderUploadTransOrderInfoPostRaw(requestParameters: OrderUploadTransOrderInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling orderUploadTransOrderInfoPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/order/uploadTransOrderInfo`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 上传运输订单 修改商品信息
     */
    async orderUploadTransOrderInfoPost(requestParameters: OrderUploadTransOrderInfoPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.orderUploadTransOrderInfoPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
